import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constants } from '../constants/constants.service';
import { DataService } from '../utils/data/data.service';
import { Session } from '../session/session.service';

@Injectable()
export class PagosService implements OnInit
{
    private authorization : string =
      "";
    constructor(
      private http: HttpClient,
      private session: Session,
      private dataService: DataService
    ){
      this.authorization += session.idToken;
    }

    ngOnInit(){}
    generarPorGruposCuentasPorMes(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/pagos/generarPorGruposCuentasPorMes",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    generarPorCuentaPorMes(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/pagos/generarPorCuentaPorMes",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    pagosPorAPRPorMesTotales(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/pagos/pagosPorAPRPorMesTotales",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    pagosPendientesNoPagadosPorCuenta(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/pagos/pagosPendientesNoPagadosPorCuenta",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    pagosPendientesPorAPRPorMesTotales(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/pagos/pagosPendientesPorAPRPorMesTotales",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    pagosPagadosPorAPRPorMesTotales(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/pagos/pagosPagadosPorAPRPorMesTotales",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    eliminarMulta(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/pagos/eliminarMulta",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    multasCuenta(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/pagos/multasCuenta",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    generarBoleta(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/pagos/generarBoleta",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    generarBoletaMulta(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/pagos/generarBoletaMulta",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    generarMulta(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/pagos/generarMulta",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    indicarPago(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/pagos/indicarPago",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    indicarPagoMulta(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/pagos/indicarPagoMulta",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    numeroUltimaBoleta(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/pagos/numeroUltimaBoleta",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    convenioPago(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/pagos/convenioPago",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    pagoPDF(data, form){
      form.action= Constants.API_BASE + "/pagos/pagoPDF";
      form.elements[0].value = this.session.currentUser.accessToken;
      form.elements[0].name = 'accessToken';
      form.elements[1].value = data.idAPR;
      form.elements[1].name = 'idAPR';
      form.elements[2].value = data.idPagos;
      form.elements[2].name = 'idPagos';
      form.elements[3].value = data.descargar;
      form.elements[3].name = 'descargar';
      form.submit();
    }

    pagosPDFPorLote(data, form){
      form.action= Constants.API_BASE + "/pagos/pagosPDFPorLote";
      form.elements[0].value = this.session.currentUser.accessToken;
      form.elements[0].name = 'accessToken';
      form.elements[1].value = data.idAPR;
      form.elements[1].name = 'idAPR';
      form.elements[2].value = data.mes;
      form.elements[2].name = 'mes';
      form.elements[3].value = data.ano;
      form.elements[4].value = data.idGruposCuentas;
      form.elements[5].value = data.descargar;
      form.elements[3].name = 'ano';
      form.elements[4].name = 'idGruposCuentas';
      form.elements[5].name = 'descargar';
      form.elements[6].value = data.indice;
      form.elements[6].name = 'indice';
      form.elements[7].value = data.maximoPorLote;
      form.elements[7].name = 'maximoPorLote';
      form.submit();
    }

    comprobantePDF(data, form){
      form.action= Constants.API_BASE + "/pagos/comprobantePDF";
      form.elements[0].value = data.codigoPagos;
      form.elements[0].name = 'codigoPagos';
      form.submit();
    }

    pagosHistoricosExcel(data, form){
      form.action= Constants.API_BASE + "/pagos/pagosHistoricosExcel";
      form.elements[0].value = this.session.currentUser.accessToken;
      form.elements[0].name = 'accessToken';
      form.elements[1].value = data.idAPR;
      form.elements[1].name = 'idAPR';
      form.elements[2].value = data.cantidadMeses;
      form.elements[2].name = 'cantidadMeses';
      form.elements[3].value = data.ano;
      form.elements[4].value = data.mes;
      form.elements[5].value = data.idGruposCuentas;
      form.elements[3].name = 'ano';
      form.elements[4].name = 'mes';
      form.elements[5].name = 'idGruposCuentas';
      form.submit();
    }

    reporteNoPago(data, form){
      form.action= Constants.API_BASE + "/pagos/reporteNoPago";
      form.elements[0].value = this.session.currentUser.accessToken;
      form.elements[0].name = 'accessToken';
      form.elements[1].value = data.idAPR;
      form.elements[1].name = 'idAPR';
      form.elements[2].name = 'ano';
      form.elements[2].value = data.ano;
      form.elements[3].value = data.idGruposCuentas;
      form.elements[3].name = 'idGruposCuentas';
      form.submit();
    }
}



// WEBPACK FOOTER //
// ./src/app/services/pagos/pagos.service.ts